import { Effect, Reducer } from '@umijs/max';

import { PayCheck } from '@/interfaces/paycheck';
import { queryPaycheck } from '@/services/paychecks.service';

export interface ModelType {
  namespace: string;
  state: { paycheck: null | PayCheck };
  effects: {
    sendHistory: Effect;
    fetchPaycheckDetail: Effect;
  };
  reducers: {
    setHistory: Reducer<any>;
    setPaycheck: Reducer<any>;
  };
}

const Model: ModelType = {
  namespace: 'paycheckDetail',

  state: {
    paycheck: null,
  },

  effects: {
    *fetchPaycheckDetail({ payload }, { call, put, all }) {
      const [paycheck] = yield all([call(queryPaycheck, payload)]);

      yield put({
        type: 'setPaycheck',
        payload: { paycheck },
      });
    },

    *sendHistory({ payload }) {
      yield {
        type: 'setHistory',
        payload,
      };
    },
  },

  reducers: {
    setPaycheck(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },

    setHistory(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};

export default Model;
